import { string } from 'yup';
import Address from 'components/interaction/Address/index.jsx';
import { makeUrl } from 'utils/urlUtils.js';
import messages from './messages.js';

const schema = {
  id: 'schoolDetails',
  properties: [
    {
      id: 'brin',
      label: messages.brin,
      type: 'readonly',
    },
    {
      id: 'name',
      label: messages.name,
      type: 'text',
      required: true,
    },
    {
      id: 'address',
      as: Address,
      label: messages.address,
      required: true,
      attributes: { singleStreet: true },
      itemToString: Address.itemToString,
    },
    {
      id: 'phone',
      label: messages.phoneNumber,
      type: 'tel',
      required: true,
    },
    {
      id: 'email',
      label: messages.email,
      type: 'email',
      attributes: {
        pattern: '[^@\\s]+@[^@\\s]+\\.[^@\\s]+',
        title: 'naam@school.nl',
      },
      required: true,
    },
    {
      id: 'websiteUrl',
      label: messages.websiteUrl,
      type: 'url',
      attributes: { placeholder: 'https://' },
      required: true,
      schema: string().transform(makeUrl).url(),
    },
  ],
};

export default schema;
